<template>
  <div>
    <!-- callback/kcb/credit -->
  </div>
</template>
<script>
export default {
  created() {
    if (window.opener != null && window.opener.kcbCreditSuccess != null) {
      window.opener.kcbCreditSuccess()
      window.close()
    } else {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
